function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
import AxiosUtils from '../../utilities/axios-utils';
import ConfigurationManager from '../configuration-manager';
import CheckUtils from '../../utilities/check-utils';

/**
 * @memberOf module:wdh-feature-b2b
 */
var ApiClientProduct = /*#__PURE__*/function () {
  function ApiClientProduct(token) {
    _classCallCheck(this, ApiClientProduct);
    this.token = token;
  }
  return _createClass(ApiClientProduct, [{
    key: "initErrorHandling",
    value: function initErrorHandling(callback) {
      this.errorHandlingCallback = callback;
    }

    /**
     * Get recently viewed products
     */
  }, {
    key: "recentlyViewed",
    value: function recentlyViewed() {
      var _this = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('api/shop/products/recently-viewed-products', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this.token)).then(function (response) {
          var result = {
            items: response.data.items
          };
          resolve(result);
        }).catch(function (err) {
          reject(err);
          _this.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get categoriy filters for a variant
    */
  }, {
    key: "getCategoryFiltersForVariant",
    value: function getCategoryFiltersForVariant(productId, variantId) {
      var _this2 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/product/variantCategoryIds/".concat(productId, "/").concat(variantId), AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this2.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this2.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get product details
    */
  }, {
    key: "getDetails",
    value: function getDetails(productId, variantId, categoryId) {
      var _this3 = this;
      var promise = new Promise(function (resolve, reject) {
        var queryUrl = "productId=".concat(productId);
        if (!CheckUtils.isNullOrEmptyNumber(variantId)) {
          queryUrl = queryUrl.concat("&variantId=".concat(variantId));
        }
        if (!CheckUtils.isNullOrEmptyNumber(categoryId)) {
          queryUrl = queryUrl.concat("&categoryId=".concat(categoryId));
        }
        axios.get("/api/product/details?".concat(queryUrl), AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this3.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this3.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get product name
    */
  }, {
    key: "getName",
    value: function getName(productId) {
      var _this4 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/product/name?productId=".concat(productId), AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this4.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this4.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get related products
    * NOTICE Child collections have different names than the Client Library
    */
  }, {
    key: "getRelated",
    value: function getRelated(productId) {
      var _this5 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/shop/products/related?productId=".concat(productId), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this5.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this5.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
  }, {
    key: "getRelatedBulkOrderNew",
    value: function getRelatedBulkOrderNew(productId) {
      var _this6 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/shop/products/new-related?productId=".concat(productId), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this6.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this6.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    //new getting all accessories api
  }, {
    key: "getAllAccessories",
    value: function getAllAccessories() {
      var _this7 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('/api/shop/products/all-accessories', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this7.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this7.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get search history
    */
  }, {
    key: "getSearchHistory",
    value: function getSearchHistory(query) {
      var _this8 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/product/search-history?query=".concat(query), AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this8.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this8.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get variants for a product
    */
  }, {
    key: "getVariants",
    value: function getVariants(productId, relatedProductId) {
      var _this9 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/product/relatedVariantsByProduct/".concat(productId, "/").concat(relatedProductId), AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this9.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this9.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * List products
    */
  }, {
    key: "list",
    value: function list(pageDetails, productListArgs) {
      var _this0 = this;
      var promise = new Promise(function (resolve, reject) {
        var queryUrl = '?api-version=1.0';
        if (productListArgs.familyId !== undefined && productListArgs.familyId !== '-1') {
          queryUrl += "&familyId=".concat(productListArgs.familyId);
        }
        if (productListArgs.modelId !== undefined && productListArgs.modelId !== '-1') {
          queryUrl += "&modelId=".concat(productListArgs.modelId);
        }
        if (productListArgs.styleId !== undefined && productListArgs.styleId !== '-1') {
          queryUrl += "&styleId=".concat(productListArgs.styleId);
        }

        // queryUrl += `&pageNumber=${pageDetails.page}&pageSize=${pageDetails.size}&previousPageSize=${pageDetails.previousSize}`;

        axios.get("/api/shop/products/browse/".concat(productListArgs.categoryId).concat(queryUrl), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this0.token)).then(function (response) {
          var result = {
            page: response.data.pageNumber,
            pageSize: response.data.pageSize,
            total: response.data.total,
            items: response.data.items
          };
          resolve(result);
        }).catch(function (err) {
          reject(err);
          _this0.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Search for products
    */
  }, {
    key: "search",
    value: function search(pageDetails, query) {
      var _this1 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/shop/products/search/".concat(query, "?pageNumber=").concat(pageDetails.page, "&pageSize=").concat(pageDetails.size), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this1.token)).then(function (response) {
          var result = {
            page: response.data.pageNumber,
            pageSize: response.data.pageSize,
            total: response.data.total,
            items: response.data.items
          };
          resolve(result);
        }).catch(function (err) {
          reject(err);
          _this1.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get LocalEpdsItems
    */
  }, {
    key: "localEPDSItem",
    value: function localEPDSItem() {
      var _this10 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/shop/products/local-Epds-itemNumbers", AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this10.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this10.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get Free Items
    */
  }, {
    key: "getFreeItemList",
    value: function getFreeItemList() {
      var _this11 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/shop/promotion/freeitem-list", AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this11.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this11.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
    /**
    * Get Free Items
    */
  }, {
    key: "getMaxFreeItemCount",
    value: function getMaxFreeItemCount() {
      var _this12 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/shop/promotion/freeitem-count", AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this12.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this12.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
  }]);
}();
export default ApiClientProduct;